module.exports = __webpack_public_path__ + "images/ds-lda-instructor-lauren-newbould-1.webp";